
// @ts-nocheck
var SectionMainPageSidebar = /** @class */ (function () {
    function SectionMainPageSidebar() {
        this.openDetailsFromHash();
        this.setupAnchorLinks();
        this.wrapSummaryText();
    }
    SectionMainPageSidebar.prototype.openDetailsFromHash = function (hash) {
        // Get hash from URL if none has been passed
        var urlHash = hash ? hash : window.location.hash;
        console.log(urlHash);
        if (urlHash == "#cookiesettings") {

        }
        
        // Check if any details needs to be opened
        if (urlHash) {
            // Split params string into seperate params
            var detailsToOpenTitles_1 = urlHash.split(',');
            // Get all detail elements in page content
            var detailsNodeList = document.querySelectorAll('.main-page__content details');
            // Convert NodeList to Array
            var details = Array.prototype.slice.call(detailsNodeList);
            // Filter Array of details
            var detailsToOpen = details.filter(function (detail) {
                // Get summary element in details elements
                var summaryElement = detail.querySelector('summary');
                if (summaryElement) {
                    // Get text content of summary element and sanitize text
                    var summaryTitle = summaryElement.innerText.replace(/ /g, '').toLowerCase();
                    // Loop over params from URL
                    for (var i = 0; i < detailsToOpenTitles_1.length; i++) {
                        // Return detail element if param matches sanitized summary text
                        if (summaryTitle && "#".concat(summaryTitle) === detailsToOpenTitles_1[i])
                            return detail;
                        break;
                    }
                }
            });
            // Loop over filtered details
            for (var i = 0; i < detailsToOpen.length; i++) {
                // Set detail open attribute to open detail
                detailsToOpen[i].open = true;
                // Scroll to detail
                // detailsToOpen[ i ].scrollIntoView( { behavior: 'smooth', block: 'start' } );
            }
        }
    };
    SectionMainPageSidebar.prototype.setupAnchorLinks = function () {
        var _this = this;
        // Get all anchor links
        var anchorLinks = document.querySelectorAll('a[href*="#"]');
        for (var i = 0; i < anchorLinks.length; i++) {
            // Add click event listener to anchor links
            anchorLinks[i].addEventListener('click', function (event) { return _this.handleAnchorLinkClicked(event); });
        }
    };
    SectionMainPageSidebar.prototype.wrapSummaryText = function () {
        var summaryElements = document.querySelectorAll('.main-page-sidebar summary');
        for (var i = 0; i < summaryElements.length; i++) {
            var summary = summaryElements[i];
            if (summary.querySelector('span.summary-text') === null) {
                var text = summary.textContent.trim();
                if (text) {
                    var span = document.createElement('span');
                    span.className = 'summary-text';
                    while (summary.firstChild) {
                        span.appendChild(summary.firstChild);
                    }
                    summary.appendChild(span);
                }
            }
        }
    };
    SectionMainPageSidebar.prototype.handleAnchorLinkClicked = function (event) {
        // Get hash from anchor link
        var anchorLink = event.currentTarget;
        var hash = anchorLink.href.split("#")[1];
        // Open details if anchor link has hash
        if (hash)
            this.openDetailsFromHash("#".concat(hash));
    };
    return SectionMainPageSidebar;
}());
new SectionMainPageSidebar();
